import * as _ from 'lodash';
import { Component, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { MdbPopoverDirective } from 'mdb-angular-ui-kit/popover';
import { PopoverService } from 'app/core/services/popover.service';

@Component({
  selector: 'app-shared-link-popover',
  templateUrl: './shared-link-popover.component.html',
  styleUrls: ['./shared-link-popover.component.scss']
})
export class SharedLinkPopoverComponent implements OnInit {

  @ViewChild('popover') popover: MdbPopoverDirective = null;

  @Input() name:any

  public localOrgData = window['localOrgData']
  public pledgeUrl = null;

  constructor(
    private popoverService: PopoverService,
    private ngZone: NgZone
  ) { }

  ngOnInit(): void {
    const user = _.get(this.localOrgData, 'user', null);
    if(user) {
      this.pledgeUrl = `${window.location.protocol}//${window.location.hostname}/@${user.handle}`
    }
  }

  onPopoverShown(): void {
    this.popoverService.list['share-org-link'] = this.popover;
  }

  onPopoverHidden(): void {
    delete this.popoverService.list['share-org-link'];
  }

  closePopover(){
    this.popover.hide()
  }


  onCopyToClipboard() {
    const label = document.getElementById('share-org-link');
    const button = label.parentElement;
    label.innerHTML = 'Copied!';
    button.style.backgroundColor = '#dddddd';
    setTimeout(() => {
      this.ngZone.run(() => {
        label.innerHTML = 'Share';
        button.style.backgroundColor = 'inherit';
      });
    }, 2000);
    this.closePopover()
  }

  shareFB() {
    window['FB'].ui({
      method: 'share',
      href: this.pledgeUrl,
      quote: this.name,
    }, function(response){});
    this.closePopover()
  }

  shareTwitter() {
    const url = this.pledgeUrl;
    const href = `https://twitter.com/intent/tweet?text=${this.name}&url=${url}&referrer=twitter`
    window.open(href, "_blank");
    this.closePopover()
  }

}
